/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";

/** Common Components */
import PropTypes from "prop-types";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import ToastService from "../../../services/toastService/ToastService";
import { teamsFormData } from "../config/Teams.data";

/** RTK Query */
import {
  useAddEditTeamMutation,
  useLazyGetTeamByIdQuery,
  useLazyGetUserListQuery,
} from "../../../app/services/teamAPI";
import { setTeamData } from "../../../app/slice/teamManagementSlice";
import TeamDetailsTabs from "./TeamProjects/teamDetailsTabs/TeamDetailsTabs";

/** Utilities */
import { mapDropdownOptions } from "../../../components/finalForms/libs/mapDropdownOptions";
import { decryptUrlData } from "../../../services/CryptoService";


const AddEditTeams = (props) => {
  
  const teamRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [teamForm, setTeamForm] = useState(teamsFormData);
  const organizationId = useSelector((state) => state.auth.user.organizationId);
  const { id } = useParams();
   let teamId = null;
   let teamName = null;

const teamData = id ? decryptUrlData(id) : null;

if (teamData && typeof teamData === "object" && teamData !== null) {
    teamId = teamData.teamId;
    // eslint-disable-next-line no-unused-vars
    teamName = teamData.teamName;
} else if (teamData) {
    teamId = teamData; 
}

  const [addEditTeam, {
    isLoading: isTeamLoading,
    isSuccess: isSucessAddEditTeam,
    data: addEditTeamData,
  },] = useAddEditTeamMutation();

  const [getUserList, {
    isFetching: isUserNameFetching,
    isSuccess: isUserName,
    data: UserNameData,
  },] = useLazyGetUserListQuery();

  const [getTeamById, {
    isFetching: isGetTeamByIdFetching,
    isSuccess: isGetTeamByIdSuccess,
    data: isGetTeamByIdData,
  },] = useLazyGetTeamByIdQuery();

  const handleSubmit = () => {

    const TeamData = teamRef.current.getFormData();
    const requestData = {
      ...TeamData,
      teamName: TeamData?.teamName,
      userId:
        TeamData?.userId && typeof TeamData?.userId === "object"
          ? TeamData?.userId.value
          : TeamData?.userId,
      isActive: TeamData?.isActive,
      organizationId: organizationId,
    };
    if (!teamId && TeamData) {
      addEditTeam(requestData);
    } else if (TeamData && teamId) {
      const requestUpdateData = {
        ...TeamData,
        teamId: teamId ?? TeamData.teamId,
        userId:
          TeamData.userId && typeof TeamData.userId === "object"
            ? TeamData.userId.value
            : TeamData.userId,
        isActive: TeamData.isActive,
        organizationId: organizationId,
      };
      addEditTeam(requestUpdateData);
    }
  };

  useEffect(() => {
    if (isSucessAddEditTeam && addEditTeamData) {
      backToList();
      ToastService.success(addEditTeamData.errorMessage);
    }
  }, [isSucessAddEditTeam, addEditTeamData]);

  useEffect(() => {
    if (isGetTeamByIdSuccess && !isGetTeamByIdFetching && isGetTeamByIdData) {
      if (isGetTeamByIdData) {
        let formData = { ...teamForm };
        formData.initialState = {
          ...teamForm.initialState,
          userId: isGetTeamByIdData.userId,
          teamName: isGetTeamByIdData.teamName,
          isActive: isGetTeamByIdData.isActive,
        };
        setTeamForm(formData);
        dispatch(setTeamData(isGetTeamByIdData));
      }
    }
  }, [isGetTeamByIdSuccess, isGetTeamByIdFetching, isGetTeamByIdData]);

  useEffect(() => {
    onreset();
    if (teamId) {
      getTeamById(teamId);
    }
  }, [getTeamById]);

  useEffect(() => {
    if (!isUserNameFetching && isUserName && UserNameData) {
      mapDropdownOptions(
        teamsFormData,
        'teamSection',
        'userId',
        UserNameData,
        'userId',
        'userName'
      );
    }
  }, [isUserNameFetching, isUserName, UserNameData]);

  useEffect(() => {
    getUserList();
  }, []);

  const onreset = () => {
    let teamformData = { ...teamsFormData };
    teamformData.initialState = { ...props.initData };
    setTeamForm(teamformData);
  };

  const backToList = () => {
    navigate("/admin/teams");
  };
  return (
    <div className="project-info center-top-space">
      <CardSection isContentLoading={isGetTeamByIdFetching || isUserNameFetching} cardTitle={`Team Information${isGetTeamByIdData?.teamName ? ` - ${isGetTeamByIdData.teamName}` : ''}`}  buttonClassName="dark-btn">
        <form>
          <div className="row mt-0 edit-project-form">
            <FormCreator
              config={teamForm}
              ref={teamRef}
              {...teamForm} />


          </div>
        </form>
        <div className="d-flex justify-content-end">
          <Buttons
            buttonTypeClassName="dark-btn"
            buttonText="Cancel"
            onClick={backToList}
          />
          <Buttons
            buttonTypeClassName="theme-btn ml-4"
            buttonText={`${teamId ? "Update" : "Add"}`}
            isLoading={isTeamLoading}
            onClick={handleSubmit}
          />
        </div>
      </CardSection>
      {teamId ? (
        <CardSection>
          <TeamDetailsTabs teamId={teamId} responsibleUser={isGetTeamByIdData?.userId} />
        </CardSection>
      ) : null}
    </div>
  );
};
AddEditTeams.propTypes = {
  initData: PropTypes.object,
};
export default AddEditTeams;
